module.exports = __webpack_public_path__ + "static/media/document_32_blue.ee38ea0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/document_32_blue.svg
// module id = 1391
// module chunks = 0